import Head from 'next/head'
import { check_login } from 'constant/check_auth'
import { getAuthKey } from 'constant/functions'
import { useRouter } from 'next/router'
import PlansPanel from '@/components/workspaces/PlansPanel'
import WorkspaceLayout from '@/layouts/WorkspaceLayout'
import { getCookie } from 'cookies-next'
import { auth_cookie_name, site_url } from 'constant/url'
import BlingHIstory from '@/components/workspaces/Plans/BlingHIstory'
import { useEffect, useState } from 'react'
import axios from 'axios'

export default function My_Account({ isLoggedIn }) {
  const router = useRouter()
  const [billing_details, setBilling_details] = useState(null)

  // effect
  useEffect(() => {
    if (getAuthKey() !== undefined) {
      //
      axios
        .get('/api/v2/invoices', {})
        .then((res) => setBilling_details(res.data))
        .catch((err) => console.log(err))
    } else {
      router.push(`/signin?to=${site_url}${router.asPath}`)
    }
  }, [router])

  return (
    check_login(router, true) && (
      <WorkspaceLayout isLoggedIn={isLoggedIn}>
        <Head>
          <meta
            key="twitter:title"
            name="twitter:title"
            content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.
"
          />
          <meta
            key="og:title"
            property="og:title"
            content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.
"
          />
          <title>Tradly – Invoices </title>
        </Head>
        <div className="flex-grow">
          {/* Billing history */}
          {billing_details?.length > 0 ? (
            <section className="p-6 space-y-6 ">
              <BlingHIstory billing_details={billing_details} />
            </section>
          ) : (
            <div className="w-full    mt-0 p-6 space-y-6  ">
              <h2 className="text-2xl text-gray-800 font-bold mb-4">Billing History</h2>
              <div className=" pt-20 max-w-[500px] flex flex-col justify-center  items-center mx-auto space-y-5  text-center  ">
                <h4 className="text-2xl font-semibold text-black">No Invoices Available</h4>
                <p>
                  Currently, there are no invoices to display. Invoices will be generated after you
                  subscribe and make a payment. Please check back later or contact support if you
                  have any questions.
                </p>
              </div>
            </div>
          )}
        </div>
      </WorkspaceLayout>
    )
  )
}

export async function getServerSideProps({ req, res, query }) {
  const isLoggedIn = getCookie(auth_cookie_name, { req, res }) ? true : false

  return { props: { isLoggedIn } }
}
